import { html, LitElement } from "lit";
import { customElement } from "lit/decorators.js";

import styles from "./text-hebrew.css";

@customElement("bp-text-hebrew")
export class TextHebrew extends LitElement {
  static styles = styles;

  render() {
    return html` <slot></slot> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-text-hebrew": TextHebrew;
  }
}
